<template>
  <div>
    <div class="px-3 py-2">
      <div class="d-flex">
        <div class="btn-home mb-4 ms-auto">
          <button type="button" class="btn btn-outline-main" @click="returnHome">
            <i class="fas fa-home-lg-alt"></i> Inicio
          </button>
        </div>
      </div>

      <div id="div-modal-cxc" class="d-flex justify-content-center">
        <div id="div-cxc" class="card w-100">
          <div
            class="card-header text-white h4 text-center"
            style="background: #900052"
          >
            <strong>CONTROL DE PRODUCTOS PSICOTRÓPICOS - LISTA IV B</strong>
          </div>
          <div class="card-body w-100">
            <div class="row">
              <!-- FILTROS -->
              <div class="col-md-12 py-2">
                <div class="row d-flex">
                  <div class="col-xl-2 col-lg-6 col-md-6 col-sm-12 mb-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-5">MES</span>
                      <v-select
                        class="text-dark form-control"
                        label="name"
                        :options="months"
                        placeholder="- Mes -"
                        v-model="filter.month"
                        :reduce="(m) => m.id"
                        required
                        :clearable="false"
                      >
                        <template slot="no-options">Sin meses</template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-6 col-md-6 col-sm-12 mb-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-5">AÑO</span>
                      <v-select
                        class="text-dark form-control"
                        label="name"
                        :options="years"
                        placeholder="- Año -"
                        v-model="filter.year"
                        :reduce="(y) => y.id"
                        required
                        :clearable="false"
                      >
                        <template slot="no-options">Sin años</template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 mb-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">PRODUCTO</span>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Buscar molécula / comercial..."
                        v-model="filter.search"
                        @keyup.enter="mtdGetData"
                      />
                    </div>
                  </div>
                  <div class="col-xl-2 col-lg-6 col-md-6 col-sm-12 mb-2">
                    <button
                      class="btn btn-sm w-100 text-white py-2"
                      style="background: #900052"
                      @click="mtdGetData"
                      :disabled="loading"
                    >
                      <i class="fas fa-search"></i>&nbsp;Buscar
                    </button>
                  </div>
                  <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 mb-2">
                    <button
                      class="btn btn-sm w-100 py-2 text-white"
                      style="background: #b91c1c"
                      @click="mtdExportPdf"
                      :disabled="loading || products.length === 0"
                    >
                      <i class="fas fa-file-pdf"></i>&nbsp;PDF
                    </button>
                  </div>
                </div>
              </div>

              <!-- RESUMEN GENERAL -->
              <div
                v-if="products.length > 0"
                class="col-md-12 mb-3"
              >
                <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center p-2 rounded" style="background: #f8f9fa; border: 1px solid #dee2e6;">
                  <div class="fw-bold" style="color: #900052;">
                    <i class="fas fa-pills"></i>
                    TOTAL PRODUCTOS: {{ products.length }}
                  </div>
                  <div class="d-flex flex-wrap gap-2">
                    <span class="badge-total badge-ingreso">
                      <i class="fas fa-box-open"></i>
                      SALDO INICIAL TOTAL: {{ grandTotalSaldoInicial }}
                    </span>
                    <span class="badge-total badge-debe">
                      <i class="fas fa-arrow-up"></i>
                      DEBE TOTAL: {{ grandTotalDebe }}
                    </span>
                    <span class="badge-total badge-haber">
                      <i class="fas fa-arrow-down"></i>
                      HABER TOTAL: {{ grandTotalHaber }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- LISTA VERTICAL DE PRODUCTOS -->
              <div class="col-md-12 mt-2" v-if="products.length > 0">
                <div
                  v-for="product in products"
                  :key="'prod-' + product.id"
                  class="product-card mb-3"
                >
                  <!-- HEADER DEL PRODUCTO -->
                  <div
                    class="product-card-header"
                    @click="toggleExpand(product.id)"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center flex-wrap gap-2"
                    >
                      <div class="d-flex align-items-center gap-3">
                        <i
                          class="fas fa-chevron-right chevron-icon"
                          :class="isExpanded(product.id) ? 'rotate-90' : ''"
                        ></i>
                        <div>
                          <div class="product-name">{{ product.name }}</div>
                          <div class="product-subtitle">
                            {{ countMovements(product.id) }} movimiento(s)
                            <span
                              v-if="countMovements(product.id) === 0"
                              class="text-muted"
                            >
                              — sin despachos en el periodo
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex gap-2 flex-wrap">
                        <span class="badge-total badge-ingreso">
                          <i class="fas fa-box-open"></i>
                          INICIAL: {{ product.saldo_inicial }}
                        </span>
                        <span class="badge-total badge-debe">
                          <i class="fas fa-arrow-up"></i>
                          DEBE: {{ getProductTotal(product.id, "debe") }}
                        </span>
                        <span class="badge-total badge-haber">
                          <i class="fas fa-arrow-down"></i>
                          HABER: {{ getProductTotal(product.id, "haber") }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- BODY EXPANDIBLE -->
                  <div v-if="isExpanded(product.id)" class="product-card-body">
                    <table class="table table-bordered align-middle table-psico">
                      <thead>
                        <tr style="background: #c9e4f0; color: #000">
                          <th class="text-center" style="width: 110px">
                            FECHA
                          </th>
                          <th class="text-center">PRESCRIPTOR</th>
                          <th class="text-center" style="width: 90px">CMP</th>
                          <th class="text-center">PACIENTE</th>
                          <th class="text-center" style="width: 70px">
                            DEBE
                          </th>
                          <th class="text-center" style="width: 70px">
                            HABER
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Saldo inicial -->
                        <tr style="background: #ffeb99; font-weight: bold">
                          <td colspan="4" class="text-end">
                            {{ mtdFormatDate(saldoInicialDate) }} - SALDO
                            INICIAL
                          </td>
                          <td class="text-center">
                            {{ product.saldo_inicial }}
                          </td>
                          <td class="text-center">0</td>
                        </tr>

                        <!-- Movimientos -->
                        <tr
                          v-for="(mov, idx) in getMovementsForProduct(
                            product.id
                          )"
                          :key="'m-' + product.id + '-' + idx"
                          :style="
                            mov.type === 'devolucion'
                              ? 'background: #b5d9a8'
                              : ''
                          "
                          class="text-center"
                        >
                          <td>{{ mtdFormatDate(mov.date) }}</td>
                          <td>
                            {{
                              mov.doctor && mov.doctor !== "--"
                                ? mov.doctor
                                : mov.type === "devolucion"
                                ? "(DEVOLUCIÓN)"
                                : "--"
                            }}
                          </td>
                          <td>
                            {{
                              mov.cmp && mov.cmp !== "--" ? mov.cmp : "--"
                            }}
                          </td>
                          <td>
                            {{
                              mov.patient && mov.patient !== "--"
                                ? mov.patient
                                : "--"
                            }}
                          </td>
                          <td>{{ mov.debe || 0 }}</td>
                          <td>{{ mov.haber || 0 }}</td>
                        </tr>

                        <!-- Sin movimientos -->
                        <tr
                          v-if="getMovementsForProduct(product.id).length === 0"
                        >
                          <td colspan="6" class="text-center text-muted py-3">
                            <i class="fas fa-inbox"></i>
                            Sin movimientos en el periodo
                          </td>
                        </tr>

                        <!-- Cierre -->
                        <tr
                          style="
                            background: #ffeb3b;
                            font-weight: bold;
                            font-size: 13px;
                          "
                        >
                          <td colspan="4" class="text-end">
                            CIERRE DEL PRODUCTO
                          </td>
                          <td class="text-center">
                            {{ getProductTotal(product.id, "debe") }}
                          </td>
                          <td class="text-center">
                            {{ getProductTotal(product.id, "haber") }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- SIN DATOS -->
              <div v-else class="col-md-12 text-center py-5">
                <i
                  class="fas fa-inbox"
                  style="font-size: 3rem; color: #ccc"
                ></i>
                <p class="mt-3 text-muted">
                  No hay productos psicotrópicos para el periodo seleccionado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";

export default {
  name: "psicotropicos-quimico-farmaceutico",
  components: { SweetAlert },
  data() {
    return {
      swal: null,
      loading: false,
      filter: {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        search: "",
      },
      months: [
        { id: 1, name: "Enero" },
        { id: 2, name: "Febrero" },
        { id: 3, name: "Marzo" },
        { id: 4, name: "Abril" },
        { id: 5, name: "Mayo" },
        { id: 6, name: "Junio" },
        { id: 7, name: "Julio" },
        { id: 8, name: "Agosto" },
        { id: 9, name: "Septiembre" },
        { id: 10, name: "Octubre" },
        { id: 11, name: "Noviembre" },
        { id: 12, name: "Diciembre" },
      ],
      years: [],
      products: [],
      movements: [],
      expandedProducts: {},
    };
  },
  computed: {
    saldoInicialDate() {
      return `${this.filter.year}-${String(this.filter.month).padStart(2, "0")}-01`;
    },
    grandTotalSaldoInicial() {
      return this.products.reduce(
        (acc, p) => acc + (parseInt(p.saldo_inicial) || 0),
        0
      );
    },
    grandTotalDebe() {
      return this.products.reduce(
        (acc, p) => acc + this.getProductTotal(p.id, "debe"),
        0
      );
    },
    grandTotalHaber() {
      return this.products.reduce(
        (acc, p) => acc + this.getProductTotal(p.id, "haber"),
        0
      );
    },
  },
  created() {
    moment.locale("es");
    const curYear = new Date().getFullYear();
    for (let i = 0; i < 3; i++) {
      this.years.push({ id: curYear - i, name: String(curYear - i) });
    }
  },
  mounted() {
    this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdGetData() {
      this.loading = true;
      this.post({
        url:
          this.$store.getters.get__url +
          "/QuimicoFarmaceutico/reports/psicotropicos",
        token: this.$store.getters.get__token,
        params: {
          month: this.filter.month,
          year: this.filter.year,
          search: this.filter.search,
        },
      })
        .then((response) => {
          if (response.statusCode === 200) {
            this.products = response.data.products || [];
            this.movements = response.data.movements || [];

            this.expandedProducts = {};
            const firstWithMoves = this.products.find(
              (p) => this.getMovementsForProduct(p.id).length > 0
            );
            if (firstWithMoves) {
              this.expandedProducts[firstWithMoves.id] = true;
            }

            if (this.products.length === 0) {
              this.$refs.SweetAlert.showWarning(
                "No se encontraron psicotrópicos para este periodo"
              );
            }
          } else {
            this.$refs.SweetAlert.showWarning("Error al obtener datos");
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    mtdExportPdf() {
      const params = new URLSearchParams({
        month: this.filter.month,
        year: this.filter.year,
        search: this.filter.search || "",
      });
      const url =
        this.$store.getters.get__url +
        "/QuimicoFarmaceutico/reports/psicotropicos/pdf?" +
        params.toString();
      window.open(url, "_blank");
    },

    getMovementsForProduct(productId) {
      return this.movements.filter((m) => m.product_id === productId);
    },

    countMovements(productId) {
      return this.getMovementsForProduct(productId).length;
    },

    getProductTotal(productId, type) {
      return this.getMovementsForProduct(productId).reduce(
        (acc, m) => acc + (parseInt(m[type]) || 0),
        0
      );
    },

    getProductFinalBalance(product) {
      const debe = this.getProductTotal(product.id, "debe");
      const haber = this.getProductTotal(product.id, "haber");
      return (product.saldo_inicial || 0) + debe - haber;
    },

    toggleExpand(productId) {
      this.$set(
        this.expandedProducts,
        productId,
        !this.expandedProducts[productId]
      );
    },
    isExpanded(productId) {
      return !!this.expandedProducts[productId];
    },

    mtdFormatDate(d) {
      if (!d) return "";
      return moment(d).format("DD/MM/YYYY");
    },

    returnHome: function () {
      this.$emit("returnHome");
    },
  },
};
</script>

<style scoped>
/* ============================================================
   Product card
   ============================================================ */
.product-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.product-card-header {
  padding: 12px 16px;
  background: #f8f9fa;
  cursor: pointer;
  transition: background 0.15s;
  user-select: none;
}

.product-card-header:hover {
  background: #eef1f4;
}

.product-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.product-subtitle {
  font-size: 11px;
  color: #888;
  margin-top: 2px;
}

.chevron-icon {
  color: #900052;
  transition: transform 0.2s ease;
  font-size: 12px;
}

.chevron-icon.rotate-90 {
  transform: rotate(90deg);
}

.product-card-body {
  padding: 0;
  border-top: 1px solid #dee2e6;
}

/* ============================================================
   Badges de resumen
   ============================================================ */
.badge-total {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 50rem;
  white-space: nowrap;
}

.badge-ingreso {
  background: #fff9c4;
  color: #856404;
  border: 1px solid #ffeeba;
}

.badge-debe {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.badge-haber {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

/* ============================================================
   Tabla de movimientos
   ============================================================ */
.table-psico {
  margin-bottom: 0;
}

.table-psico th,
.table-psico td {
  font-size: 12px;
  padding: 6px 8px;
  vertical-align: middle;
}

.table-psico thead th {
  font-weight: bold;
}

/* ============================================================
   Botón outline
   ============================================================ */
.btn-outline-main {
  border: 1px solid #900052;
  color: #900052;
  background: #ffffff;
  font-weight: bold;
  font-size: 12px;
  padding: 6px 14px;
  border-radius: 50rem;
  transition: all 0.2s ease;
}

.btn-outline-main:hover {
  background: #900052;
  color: #ffffff;
}
</style>